(function () {
  var root = document.documentElement;

  var positionsRaw = (root.getAttribute('data-frete-positions') || '').trim();
  var allowedSet = null;
  if (positionsRaw) {
    var parts = positionsRaw.split(',');
    var parsed = [];
    for (var p = 0; p < parts.length; p++) {
      var n = parseInt(parts[p], 10);
      if (!isNaN(n) && n > 0) parsed.push(n);
    }
    if (parsed.length > 0) {
      allowedSet = {};
      for (var q = 0; q < parsed.length; q++) allowedSet[parsed[q]] = true;
    }
  }

  var rawLimit = parseInt(root.getAttribute('data-frete-limit'), 10);
  if (isNaN(rawLimit) || rawLimit <= 0) rawLimit = 0;

  if (!allowedSet && rawLimit === 0) return;

  var modeKey = allowedSet ? 'pos:' + positionsRaw : 'lim:' + rawLimit;

  function applyToList(ul) {
    if (!ul || ul.dataset.freteLimitApplied === modeKey) return;
    var items = ul.children;
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (li.tagName !== 'LI') continue;
      var position = i + 1;
      var shouldShow;
      if (allowedSet) {
        shouldShow = !!allowedSet[position];
      } else {
        shouldShow = position <= rawLimit;
      }
      if (shouldShow) {
        if (li.style.display === 'none') li.style.display = '';
      } else {
        if (li.style.display !== 'none') li.style.display = 'none';
      }
    }
    if (items.length > 0) ul.dataset.freteLimitApplied = modeKey;
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    var lists = node.matches && node.matches('ul') ? [node] : [];
    if (node.querySelectorAll) {
      var found = node.querySelectorAll('ul');
      for (var i = 0; i < found.length; i++) lists.push(found[i]);
    }
    for (var j = 0; j < lists.length; j++) {
      var ul = lists[j];
      if (ul.querySelector(':scope > li .ship-name, :scope > li .ship-price')) {
        applyToList(ul);
      }
    }
  }

  scan(document.body);

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList') {
        for (var k = 0; k < m.addedNodes.length; k++) {
          scan(m.addedNodes[k]);
        }
        if (m.target) {
          scan(m.target);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
